var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-text"},[_c('p',[_vm._v("\n    "+_vm._s(_vm.question)+"\n    "),_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.linkText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }